module.exports = __webpack_public_path__ + "img/IMG-20210415-WA0009 (1).8514b101.jpg";